import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { TextH2, TextNorm } from '@/components/ui/Text'
import { AnalyticsEvent, trackEvent } from '@/lib/analytics'
import css from './SuccessPage.module.css'

const SuccessPage = () => {
    const navigate = useNavigate()
    const { workspace } = useParams<{ workspace: string }>()
    const [seconds, setSeconds] = useState(5)

    // Paywall funnel: the Stripe success redirect arrived. Deduped per workspace for
    // the browser session (remounts, back-navigation); plan_purchased (server, from
    // the Stripe webhook) stays the authoritative conversion event.
    useEffect(() => {
        const flag = `plate_checkout_tracked_${workspace ?? ''}`
        try {
            if (sessionStorage.getItem(flag)) return
        } catch {
            // storage unavailable — still track, just without the dedup
        }
        trackEvent(AnalyticsEvent.CheckoutCompleted, { workspace_url_id: workspace })
        try {
            sessionStorage.setItem(flag, '1')
        } catch {
            // ignore
        }
    }, [workspace])

    useEffect(() => {
        if (seconds === 0) {
            navigate(`/${workspace}`, { replace: true })
            return
        }
        const timer = setTimeout(() => setSeconds(s => s - 1), 1000)
        return () => clearTimeout(timer)
    }, [seconds, navigate, workspace])

    return (
        <div className={css.container}>
            <TextH2>Payment successful</TextH2>
            <TextNorm className={css.counter}>Redirecting in {seconds}...</TextNorm>
        </div>
    )
}

export default SuccessPage
